import {inject} from '@angular/core';
import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {catchError} from 'rxjs/operators';

import {AuthService} from './auth.service';
import {environment} from '@environments/environment';


export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const isApiRequest = request.url.startsWith(environment.apiUrl);
  const newRequest = isApiRequest
    ? request.clone({withCredentials: true})
    : request;

  return next(newRequest).pipe(
    catchError((error) => {
      if (error.status === 401) {
        const isLogin = newRequest.url.startsWith(`${environment.apiUrl}${AuthService.API_LOGIN}`);
        authService.logout(!isLogin);
      }
      throw error;
    })
  );
};
